import { RootState } from '../../../../../redux/root-reducer';
import { Branch } from '../../../../../shared/models/branch';
import { POS_ACTION_TYPE, PosActions } from './pos-type';

export enum POS_STATE_KEY {
  ALERT_SUCCESS = 'alert_success',
  ALERT_FAIL = 'alert_fail',
  ALERT_CANCEL_POS_SUCCESS = 'alert_cancel_pos_success',
  ALERT_CANCEL_POS_FAIL = 'alert_cancel_pos_fail',
  ALERT_DEACTIVATE_POS_SUCCESS = 'alert_deactivate_pos_success',
  ALERT_DEACTIVATE_POS_FAIL = 'alert_deactivate_pos_fail',
  POS_FOOD_MENU = 'pos_food_menu',
  POS_SHOP_DATA = 'pos_shop_data',
  POS_MENU_MODIFIER_ITEM = 'pos_menu_modifier_item',
  PREFILLED_FORM_STEP_3 = 'prefilled_form_step_3',
}

export type PosState = {
  [POS_STATE_KEY.ALERT_SUCCESS]?: boolean,
  [POS_STATE_KEY.ALERT_FAIL]?: boolean
  [POS_STATE_KEY.ALERT_CANCEL_POS_SUCCESS]?: boolean
  [POS_STATE_KEY.ALERT_CANCEL_POS_FAIL]?: boolean
  [POS_STATE_KEY.ALERT_DEACTIVATE_POS_SUCCESS]?: boolean
  [POS_STATE_KEY.ALERT_DEACTIVATE_POS_FAIL]?: boolean
  [POS_STATE_KEY.POS_FOOD_MENU]?: []
  [POS_STATE_KEY.POS_SHOP_DATA]?: Branch
  [POS_STATE_KEY.POS_MENU_MODIFIER_ITEM]?: [],
  [POS_STATE_KEY.PREFILLED_FORM_STEP_3]?: any
};

const initialState: PosState = {
  [POS_STATE_KEY.ALERT_SUCCESS]: false,
  [POS_STATE_KEY.ALERT_FAIL]: false,
  [POS_STATE_KEY.ALERT_CANCEL_POS_SUCCESS]: false,
  [POS_STATE_KEY.ALERT_CANCEL_POS_FAIL]: false,
  [POS_STATE_KEY.ALERT_DEACTIVATE_POS_SUCCESS]: false,
  [POS_STATE_KEY.ALERT_DEACTIVATE_POS_FAIL]: false,
  [POS_STATE_KEY.POS_FOOD_MENU]: [],
  [POS_STATE_KEY.POS_MENU_MODIFIER_ITEM]: []
};

export const posReducers = (state = initialState, action: PosActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case POS_ACTION_TYPE.SET_POS_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const posStateSelector = (key: POS_STATE_KEY) => (state: RootState) => state.pos[key];
